import { defineStore } from 'pinia'
import request from '@/utils/request'
import { useHeaderStore } from '@/stores/header'

export const useAccountsStore = defineStore('accounts', {
  state: () => ({
    user: undefined,
  }),

  getters: {
    userGetter: (state) => state.user,
  },

  actions: {
    updateUserMetadata (data) {
      const { subject } = this.user
      return request
        .post(`/api/auth/user/${subject}/update-metadata/`, data)
        .then(({ data }) => { this.user = data })
    },

    selectClient (client) {
      return request
        .post(`/api/auth/user/${this.user.subject}/select-client/`, { client })
        .then(({ data }) => {
          // changing client, resets the filters
          const headerStore = useHeaderStore()
          headerStore.resetFilters()
          this.user = data
        })
    },

    // Mutation exposed as action
    setUser (user) { this.user = user },
  }
})
